import { darkenColor } from "./extensions"

export class CustomerData {
  customerCreatedAccount
  customerLeadData
  customerDocuments
  customerStageHistory
  customerTOSData
  customerPlaidAgreement
  customerInvoiceData
  customerReferralCode
  customerCouponCode
  customerReceipts
  customerShippoReceipts
  customerTrackingData
  customerShippoLabels
  customerShippoTrackingData
  customerAdvanceFunding
  customerValidiFiBankVerification
  customerVerificationData
  customerQRCodeData
  accessToken

  constructor(customerAccountData = {}) {
    this.customerCreatedAccount = customerAccountData.customerCreatedAccount ? Boolean(customerAccountData.customerCreatedAccount) : false
    this.customerLeadData = customerAccountData.customerLeadData ? new CustomerLead(customerAccountData.customerLeadData) : new CustomerLead()
    this.customerStageHistory = customerAccountData.customerStageHistory ? [...customerAccountData.customerStageHistory] : []
    this.customerDocuments = customerAccountData.customerDocuments ? new CustomerDocuments(customerAccountData.customerDocuments) : new CustomerDocuments()
    this.customerTOSData = customerAccountData.customerTOSData ? new CustomerTOSData(customerAccountData.customerTOSLink) : new CustomerTOSData()
    this.customerPlaidAgreement = customerAccountData.customerPlaidAgreement ? new CustomerPlaidAgreement(customerAccountData.customerPlaidAgreement) : new CustomerPlaidAgreement()
    this.customerInvoiceData = customerAccountData.customerInvoiceData ? new CustomerInvoiceData(customerAccountData.customerInvoiceData) : new CustomerInvoiceData()
    this.customerReferralCode = customerAccountData.customerReferralCode ? new CustomerReferralCode(customerAccountData.customerReferralCode) : new CustomerReferralCode()
    this.customerCouponCode = customerAccountData.customerCouponCode ? new CustomerCouponCode(customerAccountData.customerCouponCode) : new CustomerCouponCode()
    this.customerReceipts = customerAccountData.customerReceipts ? [...customerAccountData.customerReceipts] : []
    this.customerShippoReceipts = customerAccountData.customerShippoReceipts ? [...customerAccountData.customerShippoReceipts] : []
    this.customerTrackingData = customerAccountData.customerTrackingData ? new CustomerTrackingData(customerAccountData.customerTrackingData) : new CustomerTrackingData()
    this.customerShippoLabels = customerAccountData.customerShippoLabels ? [...customerAccountData.customerShippoLabels] : []
    this.customerShippoTrackingData = customerAccountData.customerShippoTrackingData ? new CustomerShippoTrackingData(customerAccountData.customerShippoTrackingData) : new CustomerShippoTrackingData()
    this.customerAdvanceFunding = customerAccountData.customerAdvanceFunding ? new AdvanceFundingApplication(customerAccountData.customerAdvanceFunding) : new AdvanceFundingApplication()
    this.customerValidiFiBankVerification = customerAccountData.customerValidiFiBankVerification ? new ValidiFiBankVerification(customerAccountData.customerValidiFiBankVerification) : new ValidiFiBankVerification()
    this.customerVerificationData = customerAccountData.customerVerificationData ? new IDMEVerification(customerAccountData.customerVerificationData) : new IDMEVerification()
    this.customerQRCodeData = customerAccountData.customerQRCodeData ? new CustomerQRCodeData(customerAccountData.customerQRCodeData) : new CustomerQRCodeData()
    this.accessToken = customerAccountData.accessToken ? String(customerAccountData.accessToken) : ''
  }

  setCustomerData(customerAccountData) {
    this.customerCreatedAccount = customerAccountData.customerCreatedAccount ? Boolean(customerAccountData.customerCreatedAccount) : false
    this.customerLeadData = customerAccountData.customerLeadData ? new CustomerLead(customerAccountData.customerLeadData) : new CustomerLead()
    this.customerStageHistory = customerAccountData.customerStageHistory ? [...customerAccountData.customerStageHistory] : []
    this.customerDocuments = customerAccountData.customerDocuments ? new CustomerDocuments(customerAccountData.customerDocuments) : new CustomerDocuments()
    this.customerTOSData = customerAccountData.customerTOSData ? new CustomerTOSData(customerAccountData.customerTOSData) : new CustomerTOSData()
    this.customerPlaidAgreement = customerAccountData.customerPlaidAgreement ? new CustomerPlaidAgreement(customerAccountData.customerPlaidAgreement) : new CustomerPlaidAgreement()
    this.customerInvoiceData = customerAccountData.customerInvoiceData ? new CustomerInvoiceData(customerAccountData.customerInvoiceData) : new CustomerInvoiceData()
    this.customerReferralCode = customerAccountData.customerReferralCode ? new CustomerReferralCode(customerAccountData.customerReferralCode) : new CustomerReferralCode()
    this.customerCouponCode = customerAccountData.customerCouponCode ? new CustomerCouponCode(customerAccountData.customerCouponCode) : new CustomerCouponCode()
    this.customerReceipts = customerAccountData.customerReceipts ? [...customerAccountData.customerReceipts] : []
    this.customerShippoReceipts = customerAccountData.customerShippoReceipts ? [...customerAccountData.customerShippoReceipts] : []
    this.customerTrackingData = customerAccountData.customerTrackingData ? new CustomerTrackingData(customerAccountData.customerTrackingData) : new CustomerTrackingData()
    this.customerShippoLabels = customerAccountData.customerShippoLabels ? [...customerAccountData.customerShippoLabels] : []
    this.customerShippoTrackingData = customerAccountData.customerShippoTrackingData ? new CustomerShippoTrackingData(customerAccountData.customerShippoTrackingData) : new CustomerShippoTrackingData()
    this.customerAdvanceFunding = customerAccountData.customerAdvanceFunding ? new AdvanceFundingApplication(customerAccountData.customerAdvanceFunding) : new AdvanceFundingApplication()
    this.customerValidiFiBankVerification = customerAccountData.customerValidiFiBankVerification ? new ValidiFiBankVerification(customerAccountData.customerValidiFiBankVerification) : new ValidiFiBankVerification()
    this.customerVerificationData = customerAccountData.customerVerificationData ? new IDMEVerification(customerAccountData.customerVerificationData) : new IDMEVerification()
    this.customerQRCodeData = customerAccountData.customerQRCodeData ? new CustomerQRCodeData(customerAccountData.customerQRCodeData) : new CustomerQRCodeData()
    this.accessToken = customerAccountData.accessToken ? String(customerAccountData.accessToken) : ''
  }

  updateCustomerStage(newCustomerStageId, newStageId, newStageName) {
    for (const stage of this.customerStageHistory) {
      if (stage.currentStage)
        stage.currentStage = false
      if (stage.customerStageId === newCustomerStageId)
        stage.currentStage = true
    }

    this.customerLeadData.leadStage.leadStageId = newStageId
    this.customerLeadData.leadStage.leadStageName = newStageName
  }
}

export class Company {
  companyId
  companyName
  companyLogoURL
  companyFavIconURL
  companyEmail
  companyPhone
  companyURL
  companyPrimaryColor
  companyPrimaryDarkColor
  companySecondaryColor
  companySecondaryDarkColor
  companyCreatedAt

  constructor(company = {}) {
    this.companyId = company.companyId ? String(company.companyId) : ''
    this.companyName = company.companyName ? String(company.companyName) : ''
    this.companyLogoURL = company.companyLogoURL ? String(company.companyLogoURL) : ''
    this.companyFavIconURL = company.companyFavIconURL ? String(company.companyFavIconURL) : ''
    this.companyEmail = company.companyEmail ? String(company.companyEmail) : ''
    this.companyPhone = company.companyPhone ? String(company.companyPhone) : ''
    this.companyURL = company.companyURL ? String(company.companyURL) : ''
    this.companyPrimaryColor = company.companyPrimaryColor ? String(company.companyPrimaryColor) : ''
    this.companyPrimaryDarkColor = company.companyPrimaryDarkColor ? String(company.companyPrimaryDarkColor) : ''
    this.companySecondaryColor = company.companySecondaryColor ? String(company.companySecondaryColor) : ''
    this.companyCreatedAt = company.companyCreatedAt ? new Date(company.companyCreatedAt) : new Date()
  }

  setCompany(company = {}) {
    this.companyId = company.companyId ? String(company.companyId) : ''
    this.companyName = company.companyName ? String(company.companyName) : ''
    this.companyLogoURL = company.companyLogoURL ? String(company.companyLogoURL) : ''
    this.companyFavIconURL = company.companyFavIconURL ? String(company.companyFavIconURL) : ''
    this.companyEmail = company.companyEmail ? String(company.companyEmail) : ''
    this.companyPhone = company.companyPhone ? String(company.companyPhone) : ''
    this.companyURL = company.companyURL ? String(company.companyURL) : ''
    this.companyPrimaryColor = company.companyPrimaryColor ? String(company.companyPrimaryColor) : ''
    this.companyPrimaryDarkColor = company.companyPrimaryColor ? String(darkenColor(company.companyPrimaryColor, 20)) : ''
    this.companySecondaryColor = company.companySecondaryColor ? String(company.companySecondaryColor) : ''
    this.companySecondaryDarkColor = company.companySecondaryColor ? String(darkenColor(company.companySecondaryColor, 20)) : ''
    this.companyCreatedAt = company.companyCreatedAt ? new Date(company.companyCreatedAt) : new Date()
  }
}

class CustomerLead {
  leadId
  leadType
  leadEstimateRefund
  leadAmount
  leadSource
  leadCreatedAt
  leadModifiedAt
  affiliate
  leadContact
  leadStage
  isSubAffiliate

  constructor(customerLeadData = {}) {
    this.leadId = customerLeadData.leadId ? String(customerLeadData.leadId) : ''
    this.leadType = customerLeadData.leadType ? String(customerLeadData.leadType) : ''
    this.leadEstimateRefund = customerLeadData.leadEstimateRefund ? Number(customerLeadData.leadEstimateRefund) : 0
    this.leadAmount = customerLeadData.leadAmount ? Number(customerLeadData.leadAmount) : 0
    this.leadSource = customerLeadData.leadSource ? String(customerLeadData.leadSource) : ''
    this.leadCreatedAt = customerLeadData.leadCreatedAt ? new Date(customerLeadData.leadCreatedAt) : new Date()
    this.leadModifiedAt = customerLeadData.leadModifiedAt ? new Date(customerLeadData.leadModifiedAt) : new Date()
    this.affiliate = customerLeadData.affiliate ? new CustomerAffiliate(customerLeadData.affiliate) : new CustomerAffiliate()
    this.leadContact = customerLeadData.leadContact ? new CustomerContact(customerLeadData.leadContact) : new CustomerContact()
    this.leadStage = customerLeadData.leadStage ? new LeadStage(customerLeadData.leadStage) : new LeadStage()
    this.isSubAffiliate = false
  }
}

class CustomerAffiliate {
  affiliateId
  affiliateType
  affiliateName
  affiliateEmail
  affiliatePhone

  constructor(affiliateData = {}) {
    this.affiliateId = affiliateData.affiliateId ? String(affiliateData.affiliateId) : ''
    this.affiliateType = affiliateData.affiliateType ? String(affiliateData.affiliateType) : ''
    this.affiliateName = affiliateData.affiliateName ? String(affiliateData.affiliateName) : ''
    this.affiliateEmail = affiliateData.affiliateEmail ? String(affiliateData.affiliateEmail) : ''
    this.affiliatePhone = affiliateData.affiliatePhone ? String(affiliateData.affiliatePhone) : ''
  }
}

export class CustomerContact {
  contactId
  taxStatusId
  chartTaxpayerId
  chartAccessToken
  chartStatus
  chartStatusDescription
  chartInstantAccessToken
  chart
  contactName
  contactFirstName
  contactLastName
  contactEmail
  contactPhone
  contactLast4SSN
  contactBirthYear

  constructor(leadContactData = {}) {
    this.contactId = leadContactData.contactId ? String(leadContactData.contactId) : ''
    this.taxStatusId = leadContactData.taxStatusId ? String(leadContactData.taxStatusId) : ''
    this.chartTaxpayerId = leadContactData.chartTaxpayerId ? String(leadContactData.chartTaxpayerId) : ''
    this.chartAccessToken = leadContactData.chartAccessToken ? String(leadContactData.chartAccessToken) : ''
    this.chartStatus = leadContactData.chartStatus ? String(leadContactData.chartStatus) : ''
    this.chartStatusDescription = leadContactData.chartStatusDescription ? String(leadContactData.chartStatusDescription) : ''
    this.chartInstantAccessToken = leadContactData.chartInstantAccessToken ? String(leadContactData.chartInstantAccessToken) : ''
    this.contactName = leadContactData.contactName ? String(leadContactData.contactName) : ''
    this.contactFirstName = leadContactData.contactFirstName ? String(leadContactData.contactFirstName) : ''
    this.contactLastName = leadContactData.contactLastName ? String(leadContactData.contactLastName) : ''
    this.contactEmail = leadContactData.contactEmail ? String(leadContactData.contactEmail) : ''
    this.contactPhone = leadContactData.contactPhone ? String(leadContactData.contactPhone) : ''
    this.contactLast4SSN = leadContactData.contactLast4SSN ? String(leadContactData.contactLast4SSN) : ''
    this.contactBirthYear = leadContactData.contactBirthYear ? String(leadContactData.contactBirthYear) : ''
  }
}

export class ClickId {
  parameterId
  customerId
  clickid
  gclid
  fclid
  sub1
  sub2
  sub3
  sub4
  sub5
  utm_source
  utm_medium
  utm_campaign

  constructor(clickId = {}) {
    this.parameterId = clickId.parameterId ? String(clickId.parameterId) : ''
    this.customerId = clickId.customerId ? String(clickId.customerId) : ''
    this.gclid = clickId.gclid ? String(clickId.gclid) : ''
    this.fclid = clickId.fclid ? String(clickId.fclid) : ''
    this.clickid = clickId.clickid ? String(clickId.clickid) : ''
    this.sub1 = clickId.sub1 ? String(clickId.sub1) : ''
    this.sub2 = clickId.sub2 ? String(clickId.sub2) : ''
    this.sub3 = clickId.sub3 ? String(clickId.sub3) : ''
    this.sub4 = clickId.sub4 ? String(clickId.sub4) : ''
    this.sub5 = clickId.sub5 ? String(clickId.sub5) : ''
    this.utm_source = clickId.utm_source ? String(clickId.utm_source) : ''
    this.utm_medium = clickId.utm_medium ? String(clickId.utm_medium) : ''
    this.utm_campaign = clickId.utm_campaign ? String(clickId.utm_campaign) : ''
  }
}

class CustomerDocuments {
  taxDocument2020
  taxDocument2021
  taxDocument2021UF
  marriedFilingJoint
  refund2020
  refund2021
  irsBalance
  feePercentage
  customerInvoice

  constructor(customerDocumentsData = {}) {
    this.taxDocument2020 = customerDocumentsData.taxDocument2020 ? String(customerDocumentsData.taxDocument2020) : ''
    this.taxDocument2021 = customerDocumentsData.taxDocument2021 ? String(customerDocumentsData.taxDocument2021) : ''
    this.taxDocument2021UF = customerDocumentsData.taxDocument2021UF ? String(customerDocumentsData.taxDocument2021UF) : ''
    this.marriedFilingJoint = customerDocumentsData.marriedFilingJoint ? Boolean(customerDocumentsData.marriedFilingJoint) : false
    this.refund2020 = customerDocumentsData.refund2020 ? Number(customerDocumentsData.refund2020) : 0
    this.refund2021 = customerDocumentsData.refund2021 ? Number(customerDocumentsData.refund2021) : 0
    this.irsBalance = customerDocumentsData.irsBalance ? Number(customerDocumentsData.irsBalance) : 0
    this.feePercentage = customerDocumentsData.feePercentage ? Number(customerDocumentsData.feePercentage) / 100 : 0.2
    this.customerInvoice = customerDocumentsData.customerInvoice ? new CustomerInvoice(customerDocumentsData.customerInvoice) : new CustomerInvoice()
  }
}

class CustomerInvoice {
  invoiceURL
  invoiceTotal
  invoiceBalance
  invoiceDueDate
  invoiceStatus

  constructor(customerInvoiceData = {}) {
    this.invoiceURL = customerInvoiceData.invoiceURL ? String(customerInvoiceData.invoiceURL) : ''
    this.invoiceTotal = customerInvoiceData.invoiceTotal ? String(customerInvoiceData.invoiceTotal) : ''
    this.invoiceBalance = customerInvoiceData.invoiceBalance ? String(customerInvoiceData.invoiceBalance) : ''
    this.invoiceDueDate = customerInvoiceData.invoiceDueDate ? String(customerInvoiceData.invoiceDueDate) : ''
    this.invoiceStatus = customerInvoiceData.invoiceStatus ? String(customerInvoiceData.invoiceStatus) : ''
  }
}

class LeadStage {
  leadStageId
  leadStageName

  constructor(leadStageData = {}) {
    this.leadStageId = leadStageData.leadStageId ? String(leadStageData.leadStageId) : ''
    this.leadStageName = leadStageData.leadStageName ? String(leadStageData.leadStageName) : ''
  }
}

export class CustomerTOSData {
  tosId
  customerId
  tosLinkURL

  constructor(customerTOSData = {}) {
    this.tosId = customerTOSData.tosId ? String(customerTOSData.tosId) : ''
    this.customerId = customerTOSData.customerId ? String(customerTOSData.customerId) : ''
    this.tosLinkURL = customerTOSData.tosLinkURL ? String(customerTOSData.tosLinkURL) : ''
  }
}

export class CustomerPlaidAgreement {
  agreementId
  customerId
  customerIP
  customerLink
  resetAgreement
  agreementCreatedAt

  constructor(customerPlaidAgreement = {}) {
    this.agreementId = customerPlaidAgreement.agreementId ? String(customerPlaidAgreement.agreementId) : ''
    this.customerId = customerPlaidAgreement.customerId ? String(customerPlaidAgreement.customerId) : ''
    this.customerIP = customerPlaidAgreement.customerIP ? String(customerPlaidAgreement.customerIP) : ''
    this.customerLink = customerPlaidAgreement.customerLink ? String(customerPlaidAgreement.customerLink) : ''
    this.resetAgreement = Boolean(customerPlaidAgreement.resetAgreement)
    this.agreementCreatedAt = customerPlaidAgreement.agreementCreatedAt ? new Date(customerPlaidAgreement.agreementCreatedAt) : new Date()
  }
}

export class CustomerInvoiceData {
  invoiceId
  customerId
  customerVaultId
  plaidAccessToken
  invoiceNumber
  invoicePaymentType
  invoiceBillTo
  invoiceDate
  invoiceTerms
  invoiceDueDate
  invoiceDescription
  invoiceRefund
  invoiceRate
  invoiceAmount
  invoiceSubTotal
  invoiceTax
  invoiceBalanceTotal
  invoicePaid
  invoiceRemainingBalance
  invoiceBalanceDifference
  invoiceLinkURL

  constructor(customerInvoiceData = {}) {
    this.invoiceId = customerInvoiceData.invoiceId ? String(customerInvoiceData.invoiceId) : ''
    this.customerId = customerInvoiceData.customerId ? String(customerInvoiceData.customerId) : ''
    this.customerVaultId = customerInvoiceData.customerVaultId ? String(customerInvoiceData.customerVaultId) : ''
    this.plaidAccessToken = customerInvoiceData.plaidAccessToken ? String(customerInvoiceData.plaidAccessToken) : ''
    this.invoiceNumber = customerInvoiceData.invoiceNumber ? String(customerInvoiceData.invoiceNumber) : ''
    this.invoicePaymentType = customerInvoiceData.invoicePaymentType ? String(customerInvoiceData.invoicePaymentType) : ''
    this.invoiceBillTo = customerInvoiceData.invoiceBillTo ? String(customerInvoiceData.invoiceBillTo) : ''
    this.invoiceDate = customerInvoiceData.invoiceDate ? String(customerInvoiceData.invoiceDate) : ''
    this.invoiceTerms = customerInvoiceData.invoiceTerms ? String(customerInvoiceData.invoiceTerms) : ''
    this.invoiceDueDate = customerInvoiceData.invoiceDueDate ? String(customerInvoiceData.invoiceDueDate) : ''
    this.invoiceDescription = customerInvoiceData.invoiceDescription ? String(customerInvoiceData.invoiceDescription) : ''
    this.invoiceRefund = customerInvoiceData.invoiceRefund ? Number(customerInvoiceData.invoiceRefund) : 0
    this.invoiceRate = customerInvoiceData.invoiceRate ? Number(customerInvoiceData.invoiceRate) : 0
    this.invoiceAmount = customerInvoiceData.invoiceAmount ? Number(customerInvoiceData.invoiceAmount) : 0
    this.invoiceSubTotal = customerInvoiceData.invoiceSubTotal ? Number(customerInvoiceData.invoiceSubTotal) : 0
    this.invoiceTax = customerInvoiceData.invoiceTax ? Number(customerInvoiceData.invoiceTax) : 0
    this.invoiceBalanceTotal = customerInvoiceData.invoiceBalanceTotal ? Number(customerInvoiceData.invoiceBalanceTotal) : 0
    this.invoicePaid = customerInvoiceData.invoicePaid ? Boolean(customerInvoiceData.invoicePaid) : false
    this.invoiceRemainingBalance = customerInvoiceData.invoiceRemainingBalance ? Number(customerInvoiceData.invoiceRemainingBalance) : 0
    this.invoiceBalanceDifference = customerInvoiceData.invoiceBalanceDifference ? Number(customerInvoiceData.invoiceBalanceDifference) : 0
    this.invoiceLinkURL = customerInvoiceData.invoiceLinkURL ? String(customerInvoiceData.invoiceLinkURL) : ''
  }
}

export class CustomerReceiptData {
  receiptId
  customerId
  receiptNumber
  receiptBillTo
  receiptDate
  receiptPaymentType
  receiptInvoiceNumber
  receiptInvoiceDate
  receiptInvoiceAmount
  receiptPaymentAmount
  receiptLinkURL

  constructor(customerReceiptData = {}) {
    this.receiptId = customerReceiptData.receiptId ? String(customerReceiptData.receiptId) : ''
    this.customerId = customerReceiptData.customerId ? String(customerReceiptData.customerId) : ''
    this.receiptNumber = customerReceiptData.receiptNumber ? String(customerReceiptData.receiptNumber) : ''
    this.receiptBillTo = customerReceiptData.receiptBillTo ? String(customerReceiptData.receiptBillTo) : ''
    this.receiptDate = customerReceiptData.receiptDate ? String(customerReceiptData.receiptDate) : ''
    this.receiptPaymentType = customerReceiptData.receiptPaymentType ? String(customerReceiptData.receiptPaymentType) : ''
    this.receiptInvoiceNumber = customerReceiptData.receiptInvoiceNumber ? String(customerReceiptData.receiptInvoiceNumber) : ''
    this.receiptInvoiceDate = customerReceiptData.receiptInvoiceDate ? String(customerReceiptData.receiptInvoiceDate) : ''
    this.receiptInvoiceAmount = customerReceiptData.receiptInvoiceAmount ? String(customerReceiptData.receiptInvoiceAmount) : ''
    this.receiptPaymentAmount = customerReceiptData.receiptPaymentAmount ? String(customerReceiptData.receiptPaymentAmount) : ''
    this.receiptLinkURL = customerReceiptData.receiptLinkURL ? String(customerReceiptData.receiptLinkURL) : ''
  }
}

export class CustomerShippoReceiptData {
  receiptId
  customerId
  receiptNumber
  receiptBillTo
  receiptDate
  receiptPaymentType
  receiptCourier
  receiptService
  receiptPaymentAmount
  receiptLinkURL

  constructor(customerReceiptData = {}) {
    this.receiptId = customerReceiptData.receiptId ? String(customerReceiptData.receiptId) : ''
    this.customerId = customerReceiptData.customerId ? String(customerReceiptData.customerId) : ''
    this.receiptNumber = customerReceiptData.receiptNumber ? String(customerReceiptData.receiptNumber) : ''
    this.receiptBillTo = customerReceiptData.receiptBillTo ? String(customerReceiptData.receiptBillTo) : ''
    this.receiptDate = customerReceiptData.receiptDate ? String(customerReceiptData.receiptDate) : ''
    this.receiptPaymentType = customerReceiptData.receiptPaymentType ? String(customerReceiptData.receiptPaymentType) : ''
    this.receiptCourier = customerReceiptData.receiptCourier ? String(customerReceiptData.receiptCourier) : ''
    this.receiptService = customerReceiptData.receiptService ? String(customerReceiptData.receiptService) : ''
    this.receiptPaymentAmount = customerReceiptData.receiptPaymentAmount ? String(customerReceiptData.receiptPaymentAmount) : ''
    this.receiptLinkURL = customerReceiptData.receiptLinkURL ? String(customerReceiptData.receiptLinkURL) : ''
  }
}

export class CustomerTrackingData {
  trackingId
  customerId
  trackingCourier
  trackingNumber
  trackingURL

  constructor(customerTrackingData = {}) {
    this.trackingId = customerTrackingData.trackingId ? String(customerTrackingData.trackingId) : ''
    this.customerId = customerTrackingData.customerId ? String(customerTrackingData.customerId) : ''
    this.trackingCourier = customerTrackingData.trackingCourier ? String(customerTrackingData.trackingCourier) : ''
    this.trackingNumber = customerTrackingData.trackingNumber ? String(customerTrackingData.trackingNumber) : ''
    this.trackingURL = customerTrackingData.trackingURL ? String(customerTrackingData.trackingURL) : ''
  }
}

export class CustomerShippoTrackingData {
  labelId
  objectId
  customerId
  provider
  trackingNumber
  trackingStatus
  trackingURL
  labelURL
  providerImageURL

  constructor(customerShippoTrackingData = {}) {
    this.labelId = customerShippoTrackingData.labelId ? String(customerShippoTrackingData.labelId) : ''
    this.objectId = customerShippoTrackingData.objectId ? String(customerShippoTrackingData.objectId) : ''
    this.customerId = customerShippoTrackingData.customerId ? String(customerShippoTrackingData.customerId) : ''
    this.provider = customerShippoTrackingData.provider ? String(customerShippoTrackingData.provider) : ''
    this.trackingNumber = customerShippoTrackingData.trackingNumber ? String(customerShippoTrackingData.trackingNumber) : ''
    this.trackingStatus = customerShippoTrackingData.trackingStatus ? String(customerShippoTrackingData.trackingStatus) : ''
    this.trackingURL = customerShippoTrackingData.trackingURL ? String(customerShippoTrackingData.trackingURL) : ''
    this.labelURL = customerShippoTrackingData.labelURL ? String(customerShippoTrackingData.labelURL) : ''
    this.providerImageURL = customerShippoTrackingData.providerImageURL ? String(customerShippoTrackingData.providerImageURL) : ''
  }
}

export class CustomerReferralCode {
  customerId
  referralCode
  numOfUse
  numHaveRefund
  appliedReferralCode

  constructor(customerReferralCodeData = {}) {
    this.customerId = customerReferralCodeData.customerId ? String(customerReferralCodeData.customerId) : ''
    this.referralCode = customerReferralCodeData.referralCode ? String(customerReferralCodeData.referralCode) : ''
    this.numOfUse = customerReferralCodeData.numOfUse ? Number(customerReferralCodeData.numOfUse) : 0
    this.numHaveRefund = customerReferralCodeData.numHaveRefund ? Number(customerReferralCodeData.numHaveRefund) : 0
    this.appliedReferralCode = customerReferralCodeData.appliedReferralCode ? String(customerReferralCodeData.appliedReferralCode) : ''
  }
}

export class CustomerCouponCode {
  customerId
  couponCode
  couponAmount
  couponType

  constructor(customerCouponCodeData = {}) {
    this.customerId = customerCouponCodeData.customerId ? String(customerCouponCodeData.customerId) : ''
    this.couponCode = customerCouponCodeData.couponCode ? String(customerCouponCodeData.couponCode) : ''
    this.couponAmount = customerCouponCodeData.couponAmount ? Number(customerCouponCodeData.couponAmount) : 0
    this.couponType = customerCouponCodeData.couponType ? String(customerCouponCodeData.couponType) : ''
  }
}

export class CustomerDaysData {
  Child_January_1_2021
  Child_April_1_2021
  Gov_January_1_2021
  Gov_April_1_2021
  Family_January_1_2021
  Family_April_1_2021
  Day_1_6b
  Day_2_6b
  Day_3_6b
  Day_4_6b
  Day_5_6b
  Day_6_6b
  Day_7_6b
  Day_8_6b
  Day_9_6b
  Day_10_6b
  Day_1_38b
  Day_2_38b
  Day_3_38b
  Day_4_38b
  Day_5_38b
  Day_6_38b
  Day_7_38b
  Day_8_38b
  Day_9_38b
  Day_10_38b


  constructor(customerDaysData = {}) {
    this.Child_January_1_2021 = customerDaysData.Child_January_1_2021_through_March_31_2021 ? Number(customerDaysData.Child_January_1_2021_through_March_31_2021) : 10
    this.Child_April_1_2021 = customerDaysData.Child_April_1_2021_through_September_30_2021 ? Number(customerDaysData.Child_April_1_2021_through_September_30_2021) : 10
    this.Gov_January_1_2021 = customerDaysData.Gov_January_1_2021_through_March_31_2021 ? Number(customerDaysData.Gov_January_1_2021_through_March_31_2021) : 10
    this.Gov_April_1_2021 = customerDaysData.Gov_April_1_2021_through_September_30_2021 ? Number(customerDaysData.Gov_April_1_2021_through_September_30_2021) : 10
    this.Family_January_1_2021 = customerDaysData.Family_January_1_2021_through_March_31_2021 ? Number(customerDaysData.Family_January_1_2021_through_March_31_2021) : 50
    this.Family_April_1_2021 = customerDaysData.Family_April_1_2021_through_September_30_2021 ? Number(customerDaysData.Family_April_1_2021_through_September_30_2021) : 60
    this.Day_1_6b = customerDaysData.Day_11 ? String(customerDaysData.Day_11) : '2021-01-04'
    this.Day_2_6b = customerDaysData.Day_21 ? String(customerDaysData.Day_21) : '2021-01-05'
    this.Day_3_6b = customerDaysData.Day_31 ? String(customerDaysData.Day_31) : '2021-01-06'
    this.Day_4_6b = customerDaysData.Day_41 ? String(customerDaysData.Day_41) : '2021-01-07'
    this.Day_5_6b = customerDaysData.Day_51 ? String(customerDaysData.Day_51) : '2021-01-08'
    this.Day_6_6b = customerDaysData.Day_61 ? String(customerDaysData.Day_61) : '2021-01-09'
    this.Day_7_6b = customerDaysData.Day_71 ? String(customerDaysData.Day_71) : '2021-01-10'
    this.Day_8_6b = customerDaysData.Day_81 ? String(customerDaysData.Day_81) : '2021-01-11'
    this.Day_9_6b = customerDaysData.Day_91 ? String(customerDaysData.Day_91) : '2021-01-12'
    this.Day_10_6b = customerDaysData.Day_101 ? String(customerDaysData.Day_101) : '2021-01-13'
    this.Day_1_38b = customerDaysData.Day_12 ? String(customerDaysData.Day_12) : '2021-01-01'
    this.Day_2_38b = customerDaysData.Day_22 ? String(customerDaysData.Day_22) : '2021-01-02'
    this.Day_3_38b = customerDaysData.Day_32 ? String(customerDaysData.Day_32) : '2021-01-03'
    this.Day_4_38b = customerDaysData.Day_42 ? String(customerDaysData.Day_42) : '2021-01-04'
    this.Day_5_38b = customerDaysData.Day_52 ? String(customerDaysData.Day_52) : '2021-01-05'
    this.Day_6_38b = customerDaysData.Day_62 ? String(customerDaysData.Day_62) : '2021-01-06'
    this.Day_7_38b = customerDaysData.Day_72 ? String(customerDaysData.Day_72) : '2021-01-07'
    this.Day_8_38b = customerDaysData.Day_82 ? String(customerDaysData.Day_82) : '2021-01-08'
    this.Day_9_38b = customerDaysData.Day_92 ? String(customerDaysData.Day_92) : '2021-01-09'
    this.Day_10_38b = customerDaysData.Day_102 ? String(customerDaysData.Day_102) : '2021-01-10'
  }
}

export class CustomerApplication {
  applicationStep
  applicationId
  companyId
  firstName
  lastName
  email
  phone
  source
  stage
  isSelfEmployed
  isSmallOwner
  hadFamilyMember
  netIncome
  noTaxCreditGovJanuary
  taxCreditGovJanuary
  noTaxCreditGovApril
  taxCreditGovApril
  childUnder18
  taxCreditChildJanuary
  noTaxCreditChildJanuary
  taxCreditChildApril
  noTaxCreditChildApril
  filingStatus
  noSpouseTaxCreditGovJanuary
  spouseTaxCreditGovJanuary
  noSpouseTaxCreditGovApril
  spouseTaxCreditGovApril
  taxCreditFamilyJanuary
  taxCreditFamilyApril
  last4SSN
  birthYear
  gclid
  fclid
  clickid
  sub1
  sub2
  sub3
  sub4
  sub5
  utm_source
  utm_medium
  utm_campaign
  estimateRefund

  constructor(customerApplication = {}) {
    this.applicationStep = customerApplication.applicationStep ? Number(customerApplication.applicationStep) : 0
    this.applicationId = customerApplication.applicationId ? String(customerApplication.applicationId) : ''
    this.companyId = customerApplication.companyId ? String(customerApplication.companyId) : ''
    this.firstName = customerApplication.firstName ? String(customerApplication.firstName) : ''
    this.lastName = customerApplication.lastName ? String(customerApplication.lastName) : ''
    this.email = customerApplication.email ? String(customerApplication.email) : ''
    this.phone = customerApplication.phone ? String(customerApplication.phone) : ''
    this.source = customerApplication.source ? String(customerApplication.source) : ''
    this.stage = customerApplication.stage ? String(customerApplication.stage) : ''
    this.isSelfEmployed = customerApplication.isSelfEmployed ? String(customerApplication.isSelfEmployed) : ''
    this.isSmallOwner = customerApplication.isSmallOwner ? String(customerApplication.isSmallOwner) : ''
    this.hadFamilyMember = customerApplication.hadFamilyMember ? String(customerApplication.hadFamilyMember) : ''
    this.netIncome = customerApplication.netIncome ? Number(customerApplication.netIncome) : 60000
    this.noTaxCreditGovJanuary = customerApplication.noTaxCreditGovJanuary ? Boolean(customerApplication.noTaxCreditGovJanuary) : false
    this.taxCreditGovJanuary = customerApplication.taxCreditGovJanuary ? [...customerApplication.taxCreditGovJanuary] : []
    this.noTaxCreditGovApril = customerApplication.noTaxCreditGovApril ? Boolean(customerApplication.noTaxCreditGovApril) : false
    this.taxCreditGovApril = customerApplication.taxCreditGovApril ? [...customerApplication.taxCreditGovApril] : []
    this.childUnder18 = customerApplication.childUnder18 ? String(customerApplication.childUnder18) : ''
    this.taxCreditChildJanuary = customerApplication.taxCreditChildJanuary ? [...customerApplication.taxCreditChildJanuary] : []
    this.noTaxCreditChildJanuary = customerApplication.noTaxCreditChildJanuary ? Boolean(customerApplication.noTaxCreditChildJanuary) : false
    this.taxCreditChildApril = customerApplication.taxCreditChildApril ? [...customerApplication.taxCreditChildApril] : []
    this.noTaxCreditChildApril = customerApplication.noTaxCreditChildApril ? Boolean(customerApplication.noTaxCreditChildApril) : false
    this.filingStatus = customerApplication.filingStatus ? String(customerApplication.filingStatus) : 'Single'
    this.noSpouseTaxCreditGovJanuary = customerApplication.noSpouseTaxCreditGovJanuary ? Boolean(customerApplication.noSpouseTaxCreditGovJanuary) : false
    this.spouseTaxCreditGovJanuary = customerApplication.spouseTaxCreditGovJanuary ? [...customerApplication.spouseTaxCreditGovJanuary] : []
    this.noSpouseTaxCreditGovApril = customerApplication.noSpouseTaxCreditGovApril ? Boolean(customerApplication.noSpouseTaxCreditGovApril) : false
    this.spouseTaxCreditGovApril = customerApplication.spouseTaxCreditGovApril ? [...customerApplication.spouseTaxCreditGovApril] : []
    this.taxCreditFamilyJanuary = customerApplication.taxCreditFamilyJanuary ? Number(customerApplication.taxCreditFamilyJanuary) : 0
    this.taxCreditFamilyApril = customerApplication.taxCreditFamilyApril ? Number(customerApplication.taxCreditFamilyApril) : 0
    this.last4SSN = customerApplication.last4SSN ? String(customerApplication.last4SSN) : ''
    this.birthYear = customerApplication.birthYear ? String(customerApplication.birthYear) : ''
    this.gclid = customerApplication.gclid ? String(customerApplication.gclid) : ''
    this.fclid = customerApplication.fclid ? String(customerApplication.fclid) : ''
    this.clickid = customerApplication.clickid ? String(customerApplication.clickid) : ''
    this.sub1 = customerApplication.sub1 ? String(customerApplication.sub1) : ''
    this.sub2 = customerApplication.sub2 ? String(customerApplication.sub2) : ''
    this.sub3 = customerApplication.sub3 ? String(customerApplication.sub3) : ''
    this.sub4 = customerApplication.sub4 ? String(customerApplication.sub4) : ''
    this.sub5 = customerApplication.sub5 ? String(customerApplication.sub5) : ''
    this.utm_source = customerApplication.utm_source ? String(customerApplication.utm_source) : ''
    this.utm_medium = customerApplication.utm_medium ? String(customerApplication.utm_medium) : ''
    this.utm_campaign = customerApplication.utm_campaign ? String(customerApplication.utm_campaign) : ''
    this.estimateRefund = customerApplication.estimateRefund ? Number(customerApplication.estimateRefund) : 0
  }
}

export class PlaidAuthorization {
  accessToken
  padBase64
  bankInfo

  constructor(plaidAuthorization = {}) {
    this.accessToken = plaidAuthorization.accessToken ? String(plaidAuthorization.accessToken) : ''
    this.padBase64 = plaidAuthorization.padBase64 ? String(plaidAuthorization.padBase64) : ''
    this.bankInfo = plaidAuthorization.bankInfo ? new PlaidBankInfo(plaidAuthorization.bankInfo) : new PlaidBankInfo()
  }
}

class PlaidBankInfo {
  bankName
  accountInfo

  constructor(plaidBankInfo = {}) {
    this.bankName = plaidBankInfo.bankName ? String(plaidBankInfo.bankName) : ''
    this.accountInfo = plaidBankInfo.accountInfo ? new AccountInfo(plaidBankInfo.accountInfo) : new AccountInfo()
  }
}

class AccountInfo {
  accountName
  accountNumber
  accountNumberMask
  routingNumber
  isChecking
  accountEmail
  accountPhone
  accountAddressInfo

  constructor(accountInfo = {}) {
    this.accountName = accountInfo.accountName ? String(accountInfo.accountName) : ''
    this.accountNumber = accountInfo.accountNumber ? String(accountInfo.accountNumber) : ''
    this.accountNumberMask = accountInfo.accountNumberMask ? String(accountInfo.accountNumberMask) : ''
    this.routingNumber = accountInfo.routingNumber ? String(accountInfo.routingNumber) : ''
    this.isChecking = accountInfo.isChecking ? Boolean(accountInfo.isChecking) : false
    this.accountEmail = accountInfo.accountEmail ? String(accountInfo.accountEmail) : ''
    this.accountPhone = accountInfo.accountPhone ? String(accountInfo.accountPhone) : ''
    this.accountAddressInfo = accountInfo.accountAddressInfo ? new AccountAddressInfo(accountInfo.accountAddressInfo) : new AccountAddressInfo()
  }

  isValidAddress() {
    return this.accountEmail && this.accountPhone && this.accountAddressInfo.accountStreet && this.accountAddressInfo.accountCity && this.accountAddressInfo.accountState && this.accountAddressInfo.accountZip ? true : false
  }
}

class AccountAddressInfo {
  accountStreet
  accountCity
  accountState
  accountZip

  constructor(accountAddressInfo = {}) {
    this.accountStreet = accountAddressInfo.accountStreet ? String(accountAddressInfo.accountStreet) : ''
    this.accountCity = accountAddressInfo.accountCity ? String(accountAddressInfo.accountCity) : ''
    this.accountState = accountAddressInfo.accountState ? String(accountAddressInfo.accountState) : ''
    this.accountZip = accountAddressInfo.accountZip ? String(accountAddressInfo.accountZip) : ''
  }
}

export class ShippoRate {
  amount
  amountLocal
  attributes
  carrierAccount
  currency
  currencyLocal
  durationTerms
  estimatedDays
  messages
  objectCreated
  objectId
  objectOwner
  provider
  providerImage200
  providerImage75
  servicelevel
  shipment
  test

  constructor(shippoRate = {}) {
    this.amount = shippoRate.amount ? String(shippoRate.amount) : ''
    this.amountLocal = shippoRate.amountLocal ? String(shippoRate.amountLocal) : ''
    this.attributes = shippoRate.attributes ? [...shippoRate.attributes] : []
    this.carrierAccount = shippoRate.carrierAccount ? String(shippoRate.carrierAccount) : ''
    this.currency = shippoRate.currency ? String(shippoRate.currency) : ''
    this.currencyLocal = shippoRate.currencyLocal ? String(shippoRate.currencyLocal) : ''
    this.durationTerms = shippoRate.durationTerms ? String(shippoRate.durationTerms) : ''
    this.estimatedDays = shippoRate.estimatedDays ? Number(shippoRate.estimatedDays) : 0
    this.messages = shippoRate.messages ? [...shippoRate.messages] : []
    this.objectCreated = shippoRate.objectCreated ? String(shippoRate.objectCreated) : ''
    this.objectId = shippoRate.objectId ? String(shippoRate.objectId) : ''
    this.objectOwner = shippoRate.objectOwner ? String(shippoRate.objectOwner) : ''
    this.provider = shippoRate.provider ? String(shippoRate.provider) : ''
    this.providerImage200 = shippoRate.providerImage200 ? String(shippoRate.providerImage200) : ''
    this.providerImage75 = shippoRate.providerImage75 ? String(shippoRate.providerImage75) : ''
    this.servicelevel = shippoRate.servicelevel ? new ShippoRateServiceLevel(shippoRate.servicelevel) : new ShippoRateServiceLevel()
    this.shipment = shippoRate.shipment ? String(shippoRate.shipment) : ''
    this.test = Boolean(shippoRate.test ?? true)
  }
}

class ShippoRateServiceLevel {
  extendedToken
  name
  terms
  token

  constructor(shippoRateServiceLevel = {}) {
    this.extendedToken = shippoRateServiceLevel.extendedToken ? String(shippoRateServiceLevel.extendedToken) : ''
    this.name = shippoRateServiceLevel.name ? String(shippoRateServiceLevel.name) : ''
    this.terms = shippoRateServiceLevel.terms ? String(shippoRateServiceLevel.terms) : ''
    this.token = shippoRateServiceLevel.token ? String(shippoRateServiceLevel.token) : ''
  }
}

export class AddressInfo {
  street1
  street2
  city
  state
  zip
  country

  constructor(addressInfo = {}) {
    this.street1 = addressInfo.street1 ? String(addressInfo.street1) : ''
    this.street2 = addressInfo.street2 ? String(addressInfo.street2) : ''
    this.city = addressInfo.city ? String(addressInfo.city) : ''
    this.state = addressInfo.state ? String(addressInfo.state) : ''
    this.zip = addressInfo.zip ? String(addressInfo.zip) : ''
    this.country = addressInfo.country ? String(addressInfo.country) : ''
  }
}

export class AdvanceFundingApplication {
  applicationId
  leadId
  customerId
  bankApplicationId
  bankCustomerId
  bankAccountId
  applicationStep
  refundAmount
  creditAmount
  interestAmount
  loanInterestAmount
  lienAmount
  blueInkData

  constructor(advanceFundingApplication = {}) {
    this.applicationId = advanceFundingApplication.applicationId ? String(advanceFundingApplication.applicationId) : ''
    this.leadId = advanceFundingApplication.leadId ? String(advanceFundingApplication.leadId) : ''
    this.customerId = advanceFundingApplication.customerId ? String(advanceFundingApplication.customerId) : ''
    this.bankApplicationId = advanceFundingApplication.bankApplicationId ? String(advanceFundingApplication.bankApplicationId) : ''
    this.bankCustomerId = advanceFundingApplication.bankCustomerId ? String(advanceFundingApplication.bankCustomerId) : ''
    this.bankAccountId = advanceFundingApplication.bankAccountId ? String(advanceFundingApplication.bankAccountId) : ''
    this.applicationStep = advanceFundingApplication.applicationStep ? Number(advanceFundingApplication.applicationStep) : 0
    this.refundAmount = advanceFundingApplication.refundAmount ? Number(advanceFundingApplication.refundAmount) : 0
    this.creditAmount = advanceFundingApplication.creditAmount ? Number(advanceFundingApplication.creditAmount) : 0
    this.interestAmount = advanceFundingApplication.interestAmount ? Number(advanceFundingApplication.interestAmount) : 0
    this.loanInterestAmount = advanceFundingApplication.loanInterestAmount ? Number(advanceFundingApplication.loanInterestAmount) : 0
    this.lienAmount = advanceFundingApplication.lienAmount ? Number(advanceFundingApplication.lienAmount) : 0
    this.blueInkData = advanceFundingApplication.blueInkData ? new BlueInkData(advanceFundingApplication.blueInkData) : new BlueInkData()
  }
}

class BlueInkData {
  blueInkDataId
  customerId
  blueInkBundleId
  blueInkPacketId

  constructor(blueInkData = {}) {
    this.blueInkDataId = blueInkData.blueInkDataId ? String(blueInkData.blueInkDataId) : ''
    this.customerId = blueInkData.customerId ? String(blueInkData.customerId) : ''
    this.blueInkBundleId = blueInkData.blueInkBundleId ? String(blueInkData.blueInkBundleId) : ''
    this.blueInkPacketId = blueInkData.blueInkPacketId ? String(blueInkData.blueInkPacketId) : ''
  }
}

export class ValidiFiBankVerification {
  validiFiBankVerificationId
  customerId
  requestId
  transferType
  bankName
  accountType
  accountNumber
  routingNumber
  bankCity
  bankState
  approvedStatus
  accessUrl
  estimatedDepositDate

  constructor(validiFiBankVerification = {}) {
    this.validiFiBankVerificationId = validiFiBankVerification.validiFiBankVerificationId ? String(validiFiBankVerification.validiFiBankVerificationId) : ''
    this.customerId = validiFiBankVerification.customerId ? String(validiFiBankVerification.customerId) : ''
    this.requestId = validiFiBankVerification.requestId ? String(validiFiBankVerification.requestId) : ''
    this.transferType = validiFiBankVerification.transferType ? String(validiFiBankVerification.transferType) : ''
    this.bankName = validiFiBankVerification.bankName ? String(validiFiBankVerification.bankName) : ''
    this.accountType = validiFiBankVerification.accountType ? String(validiFiBankVerification.accountType) : ''
    this.accountNumber = validiFiBankVerification.accountNumber ? String(validiFiBankVerification.accountNumber) : ''
    this.routingNumber = validiFiBankVerification.routingNumber ? String(validiFiBankVerification.routingNumber) : ''
    this.bankCity = validiFiBankVerification.bankCity ? String(validiFiBankVerification.bankCity) : ''
    this.bankState = validiFiBankVerification.bankState ? String(validiFiBankVerification.bankState) : ''
    this.approvedStatus = validiFiBankVerification.approvedStatus ? String(validiFiBankVerification.approvedStatus) : ''
    this.accessUrl = validiFiBankVerification.accessUrl ? String(validiFiBankVerification.accessUrl) : ''
    this.estimatedDepositDate = validiFiBankVerification.estimatedDepositDate ? String(validiFiBankVerification.estimatedDepositDate) : ''
  }
}

export class ApplicationQuestionnaire {
  entityType
  natureOfBusiness
  entityName
  entityStreet
  entityCity
  entityState
  entityZip
  entityPhone
  ein

  constructor(applicationQuestionnaire = {}) {
    this.entityType = applicationQuestionnaire.entityType ? String(applicationQuestionnaire.entityType) : ''
    this.natureOfBusiness = applicationQuestionnaire.natureOfBusiness ? String(applicationQuestionnaire.natureOfBusiness) : ''
    this.entityName = applicationQuestionnaire.entityName ? String(applicationQuestionnaire.entityName) : ''
    this.entityStreet = applicationQuestionnaire.entityStreet ? String(applicationQuestionnaire.entityStreet) : ''
    this.entityCity = applicationQuestionnaire.entityCity ? String(applicationQuestionnaire.entityCity) : ''
    this.entityState = applicationQuestionnaire.entityState ? String(applicationQuestionnaire.entityState) : ''
    this.entityZip = applicationQuestionnaire.entityZip ? String(applicationQuestionnaire.entityZip) : ''
    this.entityPhone = applicationQuestionnaire.entityPhone ? String(applicationQuestionnaire.entityPhone) : ''
    this.ein = applicationQuestionnaire.ein ? String(applicationQuestionnaire.ein) : ''
  }
}

export class IDMEVerification {
  verificationId
  customerId
  accessToken
  refreshToken
  
  constructor(idmeVerification = {}) {
    this.verificationId = idmeVerification.verificationId ? String(idmeVerification.verificationId) : ''
    this.customerId = idmeVerification.customerId ? String(idmeVerification.customerId) : ''
    this.accessToken = idmeVerification.accessToken ? String(idmeVerification.accessToken) : ''
    this.refreshToken = idmeVerification.refreshToken ? String(idmeVerification.refreshToken) : ''
  }
}

export class CustomerShippoLabel {
  labelId
  objectId
  leadId
  customerId
  labelType
  provider
  trackingNumber
  trackingStatus
  trackingURL
  labelURL
  providerImageURL

  constructor(customerShippoLabel = {}) {
    this.labelId = customerShippoLabel.labelId ? String(customerShippoLabel.lableId) : ''
    this.objectId = customerShippoLabel.objectId ? String(customerShippoLabel.objectId) : ''
    this.leadId = customerShippoLabel.leadId ? String(customerShippoLabel.leadId) : ''
    this.customerId = customerShippoLabel.customerId ? String(customerShippoLabel.customerId) : ''
    this.labelType = customerShippoLabel.labelType ? String(customerShippoLabel.labelType) : ''
    this.provider = customerShippoLabel.provider ? String(customerShippoLabel.provider) : ''
    this.trackingNumber = customerShippoLabel.trackingNumber ? String(customerShippoLabel.trackingNumber) : ''
    this.trackingStatus = customerShippoLabel.trackingStatus ? String(customerShippoLabel.trackingStatus) : ''
    this.trackingURL = customerShippoLabel.trackingURL ? String(customerShippoLabel.trackingURL) : ''
    this.labelURL = customerShippoLabel.labelURL ? String(customerShippoLabel.labelURL) : ''
    this.providerImageURL = customerShippoLabel.providerImageURL ? String(customerShippoLabel.providerImageURL) : '' 
  }
}

export class CustomerQRCodeData {
  qrCodeId
  customerId
  qrCodeURL

  constructor(customerQRCodeData = {}) {
    this.qrCodeId = customerQRCodeData.qrCodeId ? String(customerQRCodeData.qrCodeId) : ''
    this.customerId = customerQRCodeData.customerId ? String(customerQRCodeData.customerId) : ''
    this.qrCodeURL = customerQRCodeData.qrCodeURL ? String(customerQRCodeData.qrCodeURL) : ''
  }
}

export const customerData = new CustomerData()
export const company = new Company()
export let _companies = []
export let _selectedCompanyId = ''

export function _setSelectedCompanyId(companyId) {
  _selectedCompanyId = companyId
}

export function _setCompanies(newCompanies) {
  _companies = newCompanies
}